import React from 'react'
import Data from '../../Components/Products/data'

const MainData = () => {
  return (
	 <Data />
  )
}

export default MainData